export default {
    pollingInterval: 8192,
    //pollingInterval: 30720,
    isCloseToStoreDistance: 300,
};



// WEBPACK FOOTER //
// ./src/config/params.js